import * as React from "react";

/**
 * Hotkey hint in JetBrains Mono. Show next to actions that have a global shortcut.
 */
export interface KbdProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

export function Kbd({ children, className, ...rest }: KbdProps): JSX.Element {
  return (
    <span className={["gk-kbd", className].filter(Boolean).join(" ")} {...rest}>
      {children}
    </span>
  );
}
